import { FC } from 'react'
import { Navigate, useParams } from 'react-router-dom'

type Props = {
  isExamplesPage?: boolean
}

export const WorkflowsRedirect: FC<Props> = ({ isExamplesPage }) => {
  const { slug } = useParams()

  if (isExamplesPage) {
    return <Navigate to={`/document_analysis/examples/${slug}`} replace />
  }

  if (slug) {
    return <Navigate to={`/document_analysis/${slug}`} replace />
  }

  return <Navigate to="/document_analysis" replace />
}
